import styled, { css } from 'styled-components'
import PrimaryButton from 'components/generic/PrimaryButton'
import { respondTo } from 'utils/themeUtils'

export const Container = styled.div`
  background-color: #f2f2f2;
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;
  min-height: calc(100vh - 2rem);
  padding: 1rem;

  ${respondTo.tablet`
    background-image: url(${({ backgroundImage }) => backgroundImage});
    background-repeat: no-repeat;
    background-position: bottom right;
  `}
`

export const StepHeading = styled.h2`
  color: ${({ theme }) => theme.colors.inverseColor};
  font-size: 30px;
  margin-top: 20px;
  text-align: center;
`

export const StepDescription = styled.p`
  color: ${({ theme }) => theme.colors.textColor};
  font-size: 14px;
  margin-top: -1rem;
  margin-bottom: 2rem;
  text-align: center;
`

export const BadgeImage = styled.img`
  display: block;
  top: -2rem;
  left: 50%;
  margin-left: calc(-60px / 2);
  position: absolute;
  width: 60px;

  ${respondTo.tablet`
    margin-left: calc(-70px / 2);
    width: 70px;
  `}
`

export const StepPanel = styled.div`
  background-color: #fff;
  box-shadow: 0 0 15px 0 rgba(100, 100, 105, 0.3);
  max-width: 500px;
  width: calc(100% - 2rem);
  margin: 0 auto;
  padding: 3rem 1rem 1rem;
  position: relative;
  transition: all 0.3s ease-out;

  ${respondTo.tablet`
    margin: 4rem auto;
    width: 500px;
    padding: 3rem 2rem 2rem;
  `}
`

export const LogoLink = styled.a`
  display: none;
  height: 70px;
  position: absolute;
  left: 0.5rem;
  bottom: 0.5rem;
  z-index: 0;

  img {
    width: auto;
    height: 100%;
  }

  ${respondTo.tablet`
    display: block;
  `}
`

export const ButtonOption = styled(PrimaryButton)`
  background-color: #fff;
  border-color: ${({ selected, theme }) => (selected ? theme.colors.inverseColor : '#b2b2b2')};
  border-style: solid;
  border-width: 2px;
  color: #646469;
  font-size: 14px;
  margin-bottom: 1rem;

  :hover {
    background-color: ${({ theme }) => theme.colors.grey};
  }
`

const panelContainerStyles = css`
  display: flex;
  flex-direction: column;
`

export const ContentContainer = styled.div`
  ${panelContainerStyles}
`

export const Form = styled.form`
  ${panelContainerStyles}
`

export const StepProgressBar = styled.div`
  background-color: ${({ theme }) => theme.colors.inverseColor};
  height: 0.5rem;
  position: fixed;
  top: 0;
  left: 0;
  transition: all 0.3s ease-out;
  z-index: 1;
`
